import * as Yup from 'yup';
import { baseConocimientoFormModel } from './baseConocimientoFormModel';

const {
  formField: { name, description, embeddingProvider, embeddingModel, file },
} = baseConocimientoFormModel;

export const createValidationSchema = Yup.object().shape({
  [name.name]: Yup.string().required(name.errorMsg).max(255, 'Máximo 255 caracteres'),
  [description.name]: Yup.string().max(255, 'Máximo 255 caracteres'),
  [embeddingProvider.name]: Yup.object().nullable().required(embeddingProvider.errorMsg),
  [embeddingModel.name]: Yup.object().nullable().required(embeddingModel.errorMsg),
  [file.name]: Yup.mixed().required(file.errorMsg),
});

export const editValidationSchema = Yup.object().shape({
  [name.name]: Yup.string().required(name.errorMsg).max(255, 'Máximo 255 caracteres'),
  [description.name]: Yup.string().max(255, 'Máximo 255 caracteres'),
});
